import { getLanguage } from "@Views/utils/StringUtils";
import { useEffect, useImperativeHandle, useRef } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import GuideLineForUsePopup from "./comp/GuideLineForUsePopupRef";
import RejectionEmailCollectionPopup from "./comp/RejectionEmailCollectionPopupRef";

const Footer = ({ getMsg }: any) => {
  const msg = getMsg();
  const history = useHistory();
  const footerRef: any = useRef();
  const mtnHashList = ['#/SearchStat', '#/StatisticsByTheme/KoreanStat100', '#/StatisticalResearchPublication/MainEconomyStatisticsExplainBooks', '#/ECOSHelp', '#/StatisticsByTheme/VisualStat', '#/StatisticalResearchPublication/MainStatisticsPublication'];

  const footerChange = () => {

    const hash = window.location.hash;

    if (footerRef['current']['classList'].contains("mtn")) {
      footerRef['current']['classList'].remove('mtn');
    }

    for (const item of mtnHashList) {
      if (hash.indexOf(item) !== -1) {
        footerRef['current']['classList'].add('mtn');
        break;
      }
    }

  }

  const guideLineForUsePopupRef: any = useRef();
  const rejectionEmailCollectionPopupRef: any = useRef();
  const optionRef: any = useRef();

  const onChangeOption = () => {

    window.open(optionRef['current']['value']);
  }

  useEffect(() => {
    footerChange();

    return history.listen(() => {
      footerChange();
    })
  }, [history])

  return (
    <>
      <GuideLineForUsePopup ref={guideLineForUsePopupRef} />
      <RejectionEmailCollectionPopup ref={rejectionEmailCollectionPopupRef} />
      <div className='wrap-foot' ref={footerRef}>
        <footer className="footer">
          <div className="footer-inner">
            <div className="footer-logo">
              <h1 className="logo">
                <a className="logo-link">
                  <span className={"logo-pic-" + getLanguage()}></span>
                </a>
              </h1>

            </div>
            <div className="site-info">
              <div className="site-detail">
                <ul className="site-info-list">
                  {
                    getLanguage() === 'ko' &&
                    <li className="site-info-list-item">
                      <a style={{ color: "#ff6767", fontSize: "15px", fontWeight: "bold" }} tabIndex={0} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { window.open(msg['privacyGuideLineUrl']) } }} onClick={() => window.open(msg['privacyGuideLineUrl'])}>{msg['footer']['privacyGuidelines']}</a>
                    </li>
                  }
                  <li className="site-info-list-item">
                    <a tabIndex={0} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { guideLineForUsePopupRef['current'].isOpen(true) } }} onClick={() => guideLineForUsePopupRef['current'].isOpen(true)}>{msg['footer']['GuidelineForUse']}</a>
                  </li>
                  {
                    getLanguage() === 'ko' &&
                    <li className="site-info-list-item">
                      <a tabIndex={0} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { rejectionEmailCollectionPopupRef['current'].isOpen(true) } }} onClick={() => rejectionEmailCollectionPopupRef['current'].isOpen(true)}>{msg['footer']['rejectionEmailCollection']}</a>
                    </li>
                  }
                  <li className="site-info-list-item">
                    <Link to={{ pathname: "/ECOSHelp" }} onKeyUp={(e) => { if (e['code'] === 'Space') { history.push('/ECOSHelp') } }}>{msg['footer']['siteInformation']}</Link>
                  </li>
                </ul>
                <div className="site-link">
                  <div className="btn-group">
                    <a className="btn btn-gray-outline btn-sm" tabIndex={0} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { window.open(msg['shortcutsBokUrl']) } }} onClick={() => window.open(msg['shortcutsBokUrl'])}>{msg['footer']['shortcuts']}</a>
                    {
                      getLanguage() === 'ko' &&
                      <Link to={{ pathname: "/SiteLink" }} className="btn btn-gray-outline btn-sm" onKeyUp={(e) => { if (e['code'] === 'Space') { history.push('/SiteLink') } }}>{msg['footer']['siteMap']}</Link>
                    }
                  </div>
                  {
                    getLanguage() === 'ko' ?
                      <div>
                        <div className="form-group">
                          <div className="input-box-group">
                            <div className="input-box input-box-select">
                              <label htmlFor="links" className="text-hide">통계관련사이트</label>
                              <select name="links" id="links" className="form-control form-control-sm" ref={optionRef} onChange={onChangeOption} value="">
                                <option value="" style={{ display: 'none' }}>{msg['siteMapUrlDefault']}</option>
                                <option value={msg['siteMap01Url']}>{msg['siteMap01']}</option>
                                <option value={msg['siteMap02Url']}>{msg['siteMap02']}</option>
                                <option value={msg['siteMap03Url']}>{msg['siteMap03']}</option>
                                <option value={msg['siteMap04Url']}>{msg['siteMap04']}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      : null
                  }
                </div>
              </div>
              <div className="address-set">
                <address className="address-detail">
                  <span>{msg['footer']['address']}</span>
                  <span>{msg['footer']['tel']}</span>
                </address>
                <p className="copy">{msg['copyright']}</p>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default Footer;